export default function AboutSection() {
  return (
    <section id="about" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">关于我们</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            了解私密视频播放器的定位与使命
          </p>
        </div>
        <div className="max-w-3xl mx-auto">
          <div className="p-6 md:p-8 rounded-2xl bg-background-50 border border-background-200/70">
            <div className="flex items-center gap-4 mb-5">
              <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-500">
                <i className="ri-play-circle-line text-xl text-background-50"></i>
              </span>
              <div>
                <h3 className="text-lg font-heading font-bold text-foreground-900">
                  私密视频播放器
                </h3>
                <p className="text-xs text-foreground-500">热门视频平台导航 · 成立于 2023 年</p>
              </div>
            </div>
            <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
              <p>
                私密视频播放器是一个专注于在线视频平台导航与推荐的资源聚合站。我们致力于为用户整合香蕉视频、
                红桃视频、91视频、蜜桃视频等热门视频平台入口，帮助视频爱好者快速发现优质的网络视频资源。
              </p>
              <p>
                平台运营团队持续关注在线视频行业动态，及时收录新兴视频网站，维护已有平台入口的可用性。
                无论是追看热门影视剧集，还是探索原创短视频内容，您都可以在这里找到合适的视频平台入口。
              </p>
              <p>
                我们坚持免费为用户提供视频平台导航服务，不生产内容，仅做资源聚合与入口引导。
                所有收录的视频平台均为独立运营，相关内容的版权归原作者及平台所有。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}